<template>
    <b-alert
        v-if="canSeeBlock"
        :button-title="'Go to QC module'"
        :has-content="true"
        :has-header-button="true"
        :message="'There are devices that are overdue for NEQAS probes'"
        type="error"
        @emitAction="$root.goTo($root.route('quality-control.index'))"
    >
        <div v-if="joinedItems.length">
            <span>
                {{ joinedItems }}
            </span>
        </div>
    </b-alert>
</template>

<script>
export default {
    data() {
        return {
            items: [],
            content: null,
        };
    },
    computed: {
        canSeeBlock() {
            return (
                this.hasContent &&
                (this.$store.state.user.profile.role === 'admin-dms-staff' ||
                    this.$store.state.user.profile.role === 'hcp-trained' ||
                    this.$store.state.user.profile.role === 'hcp-analyser-dispenser')
            );
        },
        joinedItems() {
            return this.items.map((item) => item.device_name).join(', ');
        },
        hasContent() {
            return this.items.length > 0;
        },
    },
    created() {
        axios.get(route('api.v1.quality-control.neqas-overdue-devices')).then((response) => {
            this.items = response.data;
        });
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-alert {
    top: 10px;
    padding: 0 20px;

    .header {
        align-items: center;
        display: flex;

        .alert-btn {
            height: 30px;
            border-color: #fff;
            right: 30px;
            padding: 0 20px !important;
        }
    }

    .v-alert__wrapper {
        &:before {
            top: 5px;
            position: relative;
        }
    }
}

.b-alert {
    padding: 0 16px;
}
</style>
